import React from 'react';
import { motion } from 'motion/react';

const CartLoadingState: React.FC = () => {
  return (
    <>
      <div className="min-h-screen bg-black">
        {/* Hero Section Skeleton */}
        <div className="relative h-64 bg-gray-900">
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black" />
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
            <div className="space-y-3">
              <div className="h-8 w-48 bg-gray-800 rounded animate-pulse" />
              <div className="h-4 w-64 bg-gray-800 rounded animate-pulse" />
            </div>
          </div>
        </div>

        {/* Cart Items Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* Cart Summary Header Skeleton */}
          <div className="mb-8">
            <div className="h-8 w-32 bg-gray-800 rounded mb-2 animate-pulse" />
            <div className="h-4 w-48 bg-gray-800 rounded animate-pulse" />
          </div>

          {/* Cart Items List Skeleton */}
          <div className="space-y-6 mb-12">
            {[1, 2].map((index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="relative rounded-2xl overflow-hidden border border-gray-800"
                style={{
                  background: 'rgba(0, 0, 0, 0.4)',
                  backdropFilter: 'blur(20px)',
                }}
              >
                {/* Header Section Skeleton */}
                <div className="relative h-48 bg-gray-800/50">
                  <div className="absolute inset-0 bg-gray-800/30" />
                  <div className="relative h-full p-6 flex flex-col justify-between">
                    <div className="space-y-2">
                      <div className="h-6 w-3/4 bg-gray-700 rounded animate-pulse" />
                      <div className="h-4 w-1/2 bg-gray-700 rounded animate-pulse" />
                    </div>
                    <div className="flex items-center gap-4">
                      <div className="h-4 w-24 bg-gray-700 rounded animate-pulse" />
                      <div className="h-4 w-20 bg-gray-700 rounded animate-pulse" />
                    </div>
                  </div>
                </div>

                {/* Content Section Skeleton */}
                <div className="p-6 bg-black/40 space-y-4">
                  {/* Guests Count Skeleton */}
                  <div className="flex items-center gap-2">
                    <div className="h-5 w-5 bg-gray-800 rounded animate-pulse" />
                    <div className="h-5 w-24 bg-gray-800 rounded animate-pulse" />
                  </div>

                  {/* Add-ons Section Skeleton */}
                  <div className="space-y-3">
                    <div className="h-4 w-32 bg-gray-800 rounded animate-pulse" />
                    <div className="flex gap-3">
                      <div className="h-20 w-20 bg-gray-800 rounded-lg animate-pulse" />
                      <div className="h-20 w-20 bg-gray-800 rounded-lg animate-pulse" />
                    </div>
                  </div>

                  {/* Price Summary Skeleton */}
                  <div className="pt-4 border-t border-gray-800 space-y-2">
                    <div className="flex justify-between">
                      <div className="h-4 w-24 bg-gray-800 rounded animate-pulse" />
                      <div className="h-4 w-20 bg-gray-800 rounded animate-pulse" />
                    </div>
                    <div className="flex justify-between">
                      <div className="h-4 w-32 bg-gray-800 rounded animate-pulse" />
                      <div className="h-4 w-24 bg-gray-800 rounded animate-pulse" />
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Payment Summary Skeleton */}
          <div className="bg-gray-900/50 border border-gray-800 rounded-xl p-6 space-y-4 mb-6">
            <div className="h-6 w-40 bg-gray-800 rounded animate-pulse" />
            <div className="space-y-3">
              <div className="flex justify-between">
                <div className="h-4 w-32 bg-gray-800 rounded animate-pulse" />
                <div className="h-4 w-24 bg-gray-800 rounded animate-pulse" />
              </div>
              <div className="flex justify-between">
                <div className="h-4 w-28 bg-gray-800 rounded animate-pulse" />
                <div className="h-4 w-20 bg-gray-800 rounded animate-pulse" />
              </div>
              <div className="pt-3 border-t border-gray-800 flex justify-between">
                <div className="h-6 w-24 bg-gray-800 rounded animate-pulse" />
                <div className="h-6 w-32 bg-gray-800 rounded animate-pulse" />
              </div>
            </div>
          </div>

          {/* Action Buttons Skeleton */}
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="h-12 w-full sm:w-48 bg-gray-800 rounded-lg animate-pulse" />
            <div className="h-12 w-full sm:w-48 bg-gray-800 rounded-lg animate-pulse" />
          </div>
        </div>
      </div>
    </>
  );
};

export default CartLoadingState;
